import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=cf8b1d7e&lang=pug"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=cf8b1d7e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports